import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button, View, Text } from '@olxbr/design-system'

const Content = styled(View)`
  display: flex;
  flex-direction: column;
`
const ButtonWrapper = styled(View)`
  margin-top: 24px;
  width: 250px;
`

class ChangePasswordBlock extends React.Component {
  onChangePasswordClick = event => {
    event.preventDefault()
    const { onChangePassword } = this.props
    if (onChangePassword && typeof onChangePassword === 'function') onChangePassword('button')
  }

  render() {
    return (
      <Content>
        <Text size="title3" weight="bold">
          Alteração de senha
        </Text>
        <Text size="caption" color="grayscale.darker">
          Escolha uma senha forte que você não esteja usando em nenhum outro lugar.
        </Text>
        <Text size="caption" color="grayscale.darker">
          Troque sua senha a cada 6 meses para aumentar a segurança da sua conta.
        </Text>
        <ButtonWrapper>
          <Button fluid size="medium" onClick={this.onChangePasswordClick}>
            Alterar senha
          </Button>
        </ButtonWrapper>
      </Content>
    )
  }
}

ChangePasswordBlock.propTypes = {
  onChangePassword: PropTypes.func.isRequired,
}

export default ChangePasswordBlock
